import useUrlFilters from "services/hooks/useUrlFilters";
import { initialFleetVehicleExpenseSearchForm } from "services/api/fleet/vehicles/expenses/consts";

import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import Tabs from "ui/components/Tabs/Tabs";

import { EXPENSE_SEARCH_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { Routes as FinanceRoutes } from "ui/modules/finance/navigation";

import { ExpenseSearchFiltersFormValues } from "./components/ExpenseSearchFilters/types";
import ExpenseSearchTab from "./components/ExpenseSearchTab/ExpenseSearchTab";
import ExpenseStatsTab from "./components/ExpenseStatsTab/ExpenseStatsTab";
import { ExpenseSearchPageCmp, ExpenseSearchPageProps } from "./types";

const ExpenseSearchPage: ExpenseSearchPageCmp = (
  _props: ExpenseSearchPageProps
) => {
  const pageTitle = EXPENSE_SEARCH_PAGE_TITLE;

  // Filter state je u parent-u tako da i Pretraga i Statistika tab gledaju
  // isti scope — promjena filtera ne resetira se prilikom prebacivanja taba.
  // Datumski raspon je sinkroniziran s URL-om (drill-down s dashboarda + share/reload).
  const [filters, setFilters] = useUrlFilters<ExpenseSearchFiltersFormValues>(
    initialFleetVehicleExpenseSearchForm,
    {
      expenseTypeId: { param: "expenseTypeId" },
      vehicleManufacturerId: { param: "vehicleManufacturerId" },
      vehicleModelId: { param: "vehicleModelId" },
      vehicleTypeId: { param: "vehicleTypeId" },
      expenseDateFrom: { param: "expenseDateFrom", type: "date" },
      expenseDateTo: { param: "expenseDateTo", type: "date-end" },
    }
  );

  return (
    <div>
      <div className="bg-white rounded-t-md border border-b mb-2">
        <PageHeader>
          <PageTitle
            title={pageTitle.text}
            icon={pageTitle.icon}
            iconColor={pageTitle.iconColor}
          />
          <Breadcrumb />
        </PageHeader>
      </div>
      <Tabs
        tabs={[
          {
            label: "Pretraga",
            queryParam: "search",
            content: <ExpenseSearchTab filters={filters} setFilters={setFilters} />,
          },
          {
            label: "Statistika",
            queryParam: "stats",
            content: <ExpenseStatsTab filters={filters} setFilters={setFilters} />,
          },
        ]}
      />
    </div>
  );
};

ExpenseSearchPage.route = FinanceRoutes.ExpenseSearchPageRouter;

export default ExpenseSearchPage;
